module.exports = __webpack_public_path__ + "img/GH-kyujin-top-030.a7ab840e.webp";